import script from "./NewTable.vue?vue&type=script&setup=true&lang=js"
export * from "./NewTable.vue?vue&type=script&setup=true&lang=js"

import "./NewTable.vue?vue&type=style&index=0&id=506e6886&lang=css"

const __exports__ = script;

export default __exports__